module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To my agent, Manie Barron, who continues to bring brilliance to projects; my editor, Monique Patterson, whose tireless dedication can be felt on every page; to the team at St. Martin’s Press, who are like family; to Eric Battle, for his wondrously creative renderings of the characters (his art is da bomb!); to Vince Natale and Michael Storrings, who continue to blow me away with their cover art and designs; to Chris Bonelli, a saint who keeps the Web site fresh; and, of course, the Rowdee Black Giants, who always inspire—"), _c('em', [_vm._v("go, brothers")]), _vm._v("—and to Zulma Gonzalez, an angel whom I am blessed to know.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209422b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 75
// module chunks = 0